import { sortOptionsFromColumns } from '@/react/common/api/sort.types';

import { buildNameColumnFromObject } from '@@/datatables/buildNameColumn';

import { EdgeConfiguration } from '../../types';

import { created } from './created';
import { groups } from './groups';
import { progress } from './progress';
import { updated } from './updated';
import { state } from './state';

export const columns = [
  buildNameColumnFromObject<EdgeConfiguration>({
    nameKey: 'name',
    path: '.item',
    dataCy: 'edge-configurations-name',
  }),
  groups,
  state,
  progress,
  created,
  updated,
];

export const sortOptions = sortOptionsFromColumns(columns);
